import { createFileRoute, Navigate } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { HomePage } from '~/features/home/home-page';
import { useMaySeeDashboard } from '~/features/insights/editor/permissions';

import { useActiveTenant } from '@/hooks/use-active-tenant';

/**
 * `/` (web-redesign-06 Decided 3): the Dashboard for a person who may see
 * insights, and Records home for anyone else. The answer waits only for the
 * membership that decides it. Under View as it is the person looked through
 * who decides (`useMaySeeDashboard`).
 */
function Home(): ReactElement | null {
  const { isLoading } = useActiveTenant();
  const maySee = useMaySeeDashboard();
  if (isLoading) return null;
  return maySee ? <Navigate to="/dashboard" replace /> : <HomePage />;
}

export const Route = createFileRoute('/_app/')({
  component: Home,
});
